import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Company } from '../../store/company/types'
import { editCompany as editCompanyAction, selectCompany as selectCompanyAction } from '../../store/company/actions'
import { getSelectedCompany } from '../../store/company/selectors'

import { Redirect } from 'react-router'
// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    selected?: Company
    route:any
}

interface IState {
    fireRedirect:any
}
// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    editCompany: typeof editCompanyAction
    selectCompany: typeof selectCompanyAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch


class CompanyViewPage extends React.Component<AllProps,IState> {

    constructor(props:AllProps){
        super(props)
        this.handleEdit = this.handleEdit.bind(this)
        this.state = {
            fireRedirect: false
        }
        const id = Number(this.props.route.match.params.id);
        this.props.selectCompany(id)
    }

    handleEdit(target:any){

        if(this.props.selected){
            this.props.editCompany({...this.props.selected})
            this.setState({ fireRedirect: true })
        }
    }

    public componentDidMount() {
        //const { fetchRequest: fr } = this.props
        //fr()
    }
    componentDidUpdate(prevProps:AllProps) {
        
    }
    private renderData() {
        const { from } = this.props.route.location.state || '/'
    
        const {   selected } = this.props
        const { fireRedirect } = this.state
        const id = Number(this.props.route.match.params.id);
        return (
            <div>
                
                {
                    selected !== undefined && (
                        <div onClick={this.handleEdit} >{selected.id} - {selected.name}</div>
                    
                        )
                    
                        
                    
                }
                {
                    fireRedirect && (
                        <Redirect to={from || '/Company/EditCompany/' +id}/>
                    )
                }
            </div>
        )
    }

    public render() {

        return (
            <div>
                {this.renderData()}
            </div>
        )
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    //data:company.data,
    selected: getSelectedCompany(state)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    editCompany:editCompanyAction,
    selectCompany:selectCompanyAction
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CompanyViewPage)
